import AllWinsMediators from 'Mediator/all-wins-mediator';
import { GameType, DOServerKeys } from 'names/do-names';
import { HideAllLinesCommand } from 'slotworks/commands/lines/hide-all-lines-command';
import Components from 'slotworks/components/components';
import Layers from 'slotworks/graphics/layers/layers';
import AutoplayModel from 'slotworks/model/autoplay-model';
import Bet from 'slotworks/model/bets/bet-model';
import GameState from 'slotworks/model/game-state';
import FreespinRecord from 'slotworks/model/gameplay/records/freespin-record';
import Record from 'slotworks/model/gameplay/records/record';
import LineResult from 'slotworks/model/gameplay/records/results/line-result';
import SpinRecord from 'slotworks/model/gameplay/records/spin-record';
import soundManager from 'slotworks/sound/sound-manager';
import State from 'slotworks/state-machine/states/state';
import { parallel } from 'slotworks/utils/race-utils';
import Timer from 'slotworks/utils/timer';
import GameInit from './game-init';
import BonusResult from 'slotworks/model/gameplay/records/results/bonus-result';
import FreeSpinsRecord from 'integration/freespin-record';
import regulation from 'slotworks/integration/revolver/regulations/regulation';

export default class ShowWinLines extends State {
    public static MULTILINE_ONLY: boolean = false;
    public static WIN_TICK_TIME: number = 750;
    public static END_DELAY: number = 0;
    public static FREESPIN_EXIT: boolean = false;

    private onDisplayComplete: Function;
    private timer: any;
    private skipped: boolean = false;

    public onEnter() {
        const record = GameState.getCurrentGame().getCurrentRecord();
        const results = record.results;

        let totalWin = GameState.getCurrentGame().totalCreditsWon;
        if (GameInit.gameType !== GameType.default) {
            totalWin = GameInit.freeSpinsWin;
        }

        if(GameInit.gameType == GameType.default && GameState.getCurrentGame().isBuyout) {
            this.complete();
            return;
        }

        let isBigWin = Components.bigWin.isBigWin(totalWin, Bet.getTotalBet());
        if (isBigWin) soundManager.customEvent('multiline_display_start');
        const lines = [];

        for (const result of results) {
            if (result instanceof LineResult) {
                lines.push(result.line);
            }
        }

        this.skipped = false;
        if (lines.length != 0 && lines != null && lines != undefined) {
            const raceFuncs = [];
            const result = results[0] as LineResult;
            if (this.hasOneLine(lines) && this.onlyShowOnMultipleWinLines(record)) {
                Components.betBar.winnings.setWinnings(record.creditsWon, totalWin, 0);
                this.complete();
                return;
            }
            if (lines.length <= 1 && result != null) {
                const record = GameState.getCurrentGame().getCurrentRecord() as SpinRecord;
                record.timesCycled = 2;
                let isBigWin = Components.bigWin.isBigWin(record.creditsWon, Bet.getTotalBet());
                if (!(GameInit.gameType === GameType.default && isBigWin) || 
                        (GameInit.gameType === GameType.default && this.isBonusOrFreespinsTriggered(record))) {
                    raceFuncs.push(() => Components.celebrateWin.singleTotalWin(record.creditsWon, result));
                }
            } else {
                let isBigWin = Components.bigWin.isBigWin(record.creditsWon, Bet.getTotalBet());
                if (!(GameInit.gameType === GameType.default && isBigWin) || 
                        (GameInit.gameType === GameType.default && this.isBonusOrFreespinsTriggered(record))) {
                    raceFuncs.push(() => Components.celebrateWin.totalWin(record.creditsWon));
                }
            }
            const allWinsMediator = new AllWinsMediators();
            Layers.Banners.getAnimatedSprite('title_sweep').gotoAndPlay(0);
            raceFuncs.push(() => allWinsMediator.start());

            this.onDisplayComplete = () => {
                Components.betBar.setCurrentWin(record.creditsWon);
                HideAllLinesCommand().execute();
                Components.celebrateWin.hide();
                regulation.updateNetPosition(GameState.getNetPosition());
                if (GameInit.gameType !== GameType.default) Components.betBar.winnings.setWinnings(totalWin, totalWin, 750);
                else Components.betBar.winnings.setWinnings(record.creditsWon, totalWin, 750);
            };

            this.timer = parallel(raceFuncs).then(() => {
                this.skipped ? this.onDisplayComplete() : this.onSkip(); 
            });
        } else {
            this.complete();
        }
    }

    public onSkip() {
        this.skipped = true;
        soundManager.customEvent('stop_start_spin_sounds');
        Timer.clearTimeout(this.timer);
        this.onDisplayComplete();
        if (GameInit.gameType === GameType.bonusGame) {
            GameInit.celebrateWin.hide();
        }
        this.complete();
    }

    private isBonusOrFreespinsTriggered(record: any) {
        const fsresult = (record.getResultsOfType(FreeSpinsRecord) as FreeSpinsRecord[])[0];
        const isBonusTriggered = record.getResultsOfType(BonusResult)[0]?.id === 'BONUS'; 
        let isFreespinsTriggered = false;
        if (fsresult) {
            isFreespinsTriggered = fsresult.triggering_game == DOServerKeys.FREESPIN || fsresult.gameName == DOServerKeys.FREESPIN;
            if (fsresult.beenPaid || fsresult.recover == true) {
                isFreespinsTriggered = false;
            }
        }
        return isFreespinsTriggered || isBonusTriggered;      
    }

    private hasOneLine(lines: number[]) {
        return lines.length <= 1;
    }

    private isAutospinsOrFreespins(record: Record) {
        return record instanceof FreespinRecord || AutoplayModel.isAutoPlaying();
    }

    private onlyShowOnMultipleWinLines(record: Record) {
        return !this.isAutospinsOrFreespins(record) && ShowWinLines.MULTILINE_ONLY;
    }
}



// WEBPACK FOOTER //
// ./src/states/show-win-line.ts